import { writable } from "svelte/store";

/** @typedef {import('$lib/types').MagentoCustomer} MagentoCustomer */

/** @type {MagentoCustomer | null} */
const customerInfo = null;
export const customer = writable(customerInfo);